import React from 'react';
import NoValue from '../EmptyStates/NoValue';

const PhoneNumber = ({phoneNumber}) => {
    if (!phoneNumber) {
        return <NoValue />;
    }

    const display = phoneNumber.replace('+44', '0')

    return <a href={`tel:${phoneNumber}`} className="link">{display}</a>;
}

export default PhoneNumber;